import { createFileRoute, Navigate } from "@tanstack/react-router";
import { RejectionReasonsOverviewPage } from "@/pages/rejection-reasons-overview/ui/rejection-reasons-overview-page";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";

const RejectionReasonsOverviewRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();

  // Redirect non-admin users
  if (!isOwnerOrAdmin) {
    return <Navigate to="/" replace />;
  }

  return <RejectionReasonsOverviewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/rejection-reason",
)({
  component: RejectionReasonsOverviewRoute,
});
